import { Node, mergeAttributes } from '@tiptap/core'
import { DEFAULT_ICON } from './iconListIcons'
import { normalizeHexColor } from './colorAttributes'

const DEFAULT_ICON_COLOR = '#1f2937'

export const IconListNode = Node.create({
  name: 'iconList',

  group: 'block',

  content: 'iconListItem+',

  defining: true,

  addAttributes() {
    return {
      iconColor: {
        default: DEFAULT_ICON_COLOR,
        parseHTML: element => normalizeHexColor(element.getAttribute('data-icon-color')) || DEFAULT_ICON_COLOR,
        renderHTML: attributes => ({ 'data-icon-color': attributes.iconColor }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'ul[data-type="icon-list"]',
      },
    ]
  },

  renderHTML({ HTMLAttributes, node }) {
    return [
      'ul',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'icon-list',
        style: `list-style:none;padding-left:0;margin:16px 0 0;color:${node.attrs.iconColor};`,
      }),
      0,
    ]
  },

  addCommands() {
    return {
      insertIconList: () => ({ chain }) => {
        return chain()
          .insertContent({
            type: this.name,
            content: [
              {
                type: 'iconListItem',
                attrs: { icon: DEFAULT_ICON },
              },
            ],
          })
          .run()
      },
    }
  },
})

export default IconListNode
